import { FormattedMessage } from 'react-intl';

import type { FiltersGroup } from '@sorare/core/src/lib/filters';
import { cardAttributes, navLabels } from '@sorare/core/src/lib/glossary';

import {
  RefineBackendPosition,
  RefineCompetitionEligibility,
  RefinePosition,
} from 'searchCards';
import {
  RefineBackendPlayer,
  RefineBackendPlayingStatus,
} from 'searchCards/RefineList';
import { MatchInfoGroup, PlayerGroup } from 'searchCards/football/cardFilters';

import { BackendFloorPricesGroup, FloorPricesGroup } from './common';

export const CompetitionEligibilityGroup = {
  slug: 'eligibility',
  title: <FormattedMessage {...navLabels.gamingCompetitions} />,
  filters: [RefineCompetitionEligibility],
};

export const scoutingCenterMarketFilters: FiltersGroup[] = [
  FloorPricesGroup,
  PlayerGroup({
    withPositions: true,
    withPlayingStatus: true,
  }),
  MatchInfoGroup,
];

export const scoutingCenterBackendMarketFilters: FiltersGroup[] = [
  BackendFloorPricesGroup,
  {
    slug: 'player',
    title: <FormattedMessage {...cardAttributes.player} />,
    filters: [
      RefineBackendPosition(),
      RefineBackendPlayingStatus,
      // RefineCardPlayerAge,
      // ...((props?.withoutNationalTeam && []) || [RefineNationality]),
      RefineBackendPlayer,
      // RefineActiveLeague(),
      // ...((props?.withoutActiveClub && []) || [RefineActiveClub()]),
      // ...((props?.withoutNationalTeam && []) || [RefineActiveNationalTeam]),
    ].filter(Boolean),
  },
  // MatchInfoGroup,
];

export const scoutingCenterMarketDropdownFilters = [RefinePosition()];
export const scoutingCenterBackendMarketDropdownFilters = [
  RefineBackendPosition(),
];
